module.exports = __webpack_public_path__ + "static/media/12.a5791ac3.png";